import { baseURL } from '../config/config';

const LOCAL_PORT = 45678;
const LOCAL_BASE = 'http://127.0.0.1:' + LOCAL_PORT;

function buildConnectParams(userId, origin) {
  const device_id = Date.now().toString(36) + Math.random().toString(36).substring(2);
  const resolvedOrigin = origin || window.location.origin;
  const graphql_url = baseURL + '/workfreeli';
  const xmpp_domain = process.env.REACT_APP_XMPP_DOMAIN || '';
  const auth_token = localStorage.getItem('token') || '';
  return { user_id: userId, auth_token, device_id, origin: resolvedOrigin, graphql_url, xmpp_domain };
}

/** Returns true if the Electron desktop app is running on this machine. */
export async function probeElectronApp() {
  try {
    const res = await fetch(LOCAL_BASE + '/ping', {
      signal: AbortSignal.timeout(800),
    });
    if (!res.ok) return false;
    const data = await res.json();
    return data.running === true;
  } catch (_) {
    return false;
  }
}

/** Send credentials directly to the running Electron app via localhost HTTP.
 *  Returns true on success, false if the app is not reachable. */
export async function connectElectronAppHttp(userId, origin) {
  if (!userId) return false;
  try {
    const res = await fetch(LOCAL_BASE + '/connect', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(buildConnectParams(userId, origin)),
      signal: AbortSignal.timeout(3000),
    });
    return res.ok;
  } catch (_) {
    return false;
  }
}

export async function connectElectronApp(userId, origin) {
  if (!userId) return;

  // // HTTP path — works silently, no browser prompt
  // const ok = await connectElectronAppHttp(userId, origin);
  // if (ok) return;

  // Deep-link iframe (requires protocol handler, may need user gesture)
  const params = new URLSearchParams(buildConnectParams(userId, origin));
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `jitsi-meet://freeli-auth?${params.toString()}`;
  document.body.appendChild(iframe);
  setTimeout(() => document.body.removeChild(iframe), 1000);
}

/** Decode user id from a JWT string. Returns null on failure. */
export function jwtUserId(token) {
  try {
    return JSON.parse(atob(token.split('.')[1])).id || null;
  } catch (_) {
    return null;
  }
}
